import { FC, useEffect, useState } from 'react';
import { PWC } from '~/adapters/typescript/propsWithChildren';
import { useFeatureFlag } from '~/adapters/optimizely/fullstack';
import { NAVIGATION_BLOCKING_TIMEOUT } from '~/adapters/tracking/tracking';
import { trackFeatureFlag } from '~/adapters/optimizely/trackFeatureFlag';
import { FullLayoutLoader } from '~/components/Layout/FullLayoutLoader';

// flag key for auth0 in FullStack
const AUTH0_FLAG_KEY = 'auth0_rollout';

/**
 * Send GA event for auth0 Optimizely feature flag.
 * Block rendering until confirmation on sending the GA.
 * Must be USED ONLY under OptimizelyProvider that provides FullstackOptimizely!
 * TODO delete this after auth0 rollout https://customink.monday.com/boards/3548701582/pulses/4348417807
 */
export const IdentityProviderFeatureFlagTracker: FC<PWC> = ({ children }) => {
    const [trackingCompleted, setTrackingCompleted] = useState(false);
    const completeTracking = () => setTrackingCompleted(true);
    const flagVariation = useFeatureFlag(AUTH0_FLAG_KEY);

    useEffect(() => {
        // release the render blocking in case the GA is unsuccessful
        setTimeout(completeTracking, NAVIGATION_BLOCKING_TIMEOUT);

        // track the feature flag
        trackFeatureFlag(AUTH0_FLAG_KEY, flagVariation, undefined, completeTracking);
    }, [flagVariation]);

    if (!trackingCompleted) {
        return <FullLayoutLoader devLabel="Auth0 GA tracking" />;
    }

    return <>{children}</>;
};
